import script from "./BButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BButton.vue?vue&type=script&setup=true&lang=js"

import "./BButton.vue?vue&type=style&index=0&id=0286098c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0286098c"]])

export default __exports__